// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1JIGS","footer":"Form_footer__3oqHL"};